import { types, isType } from "mobx-state-tree"
import { getCustomWagersByWagerId, getCustomWagersByBytes32Id } from "../api-calls/customWagers"
import { CustomWager } from "../models/CustomWager";

const CustomWagerStoreModel = types
    .model('CustomWagerStore', {
        loading: types.boolean,
        loaded: types.boolean,
        newCustomWager: types.map(CustomWager),
        singleCustomWager: types.map(CustomWager),
        singleCustomWagerBytes32Id: types.map(CustomWager)
    })
    .views(self => {
        return {
            // View Here
        }
    })
    .actions(self => {
        return {
            querySingleCustomWager: async (wagerId) => {
                self.resetSearchResults();
                getCustomWagersByWagerId(wagerId).then((wager) => {
                    self.setSingleCustomWager(wager);
                });
                return self.singleCustomWager;
            },
            setSingleCustomWager: (wager) => {
                self.singleCustomWager.put(wager);
            },
            querySingleCustomWagerByBytes32Id: async (bytes32Id) => {
                self.resetCustomWagerByBytes32Id();
                getCustomWagersByBytes32Id(bytes32Id).then((wager) => {
                    self.setSingleCustomWagerByBytes32Id(wager);
                });
                return self.singleCustomWagerBytes32Id;
            },
            setSingleCustomWagerByBytes32Id: (wager) => {
                self.singleCustomWagerBytes32Id.put(wager);
            },
            setLoading: (loading) => {
                self.loading = loading;
            },
            setLoaded: (loaded) => {
                self.loaded = loaded;
            },
            resetSearchResults: () => {
                self.singleCustomWager = {}
            },
            resetCustomWagerByBytes32Id: () => {
                self.singleCustomWagerBytes32Id = {}
            },
            setBytes32Id: (value) => {
                self.newCustomWager.bytes32Id = value;
            },
            setMaker: (value) => {
                self.newCustomWager.maker = value;
            },
            setJudge: (value) => {
                self.newCustomWager.judge = value;
            },
            setValue: (value) => {
                self.newCustomWager.value = value;
            },
            setOdds: (value) => {
                self.newCustomWager.odds = value;
            },
            setEndTime: (value) => {
                self.newCustomWager.endTime = value;
            },
            setReportingEndTime: (value) => {
                self.newCustomWager.reportingEndTime = value;
            },
            setOutcomeOne: (value) => {
                self.newCustomWager.outcomeOne = value;
            },
            setOutcomeTwo: (value) => {
                self.newCustomWager.outcomeTwo = value;
            }
        }
    });

const CustomWagerStore = CustomWagerStoreModel.create({
    loaded: false,
    loading: false,
    newCustomWager: {},
    singleCustomWager: {},
    singleCustomWagerBytes32Id: {}
});

export default CustomWagerStore;


// WEBPACK FOOTER //
// ./src/stores/CustomWagerStore.js